const PAGES_KEY = "erpPagination";
const EXPIRES_KEY = "erpPaginationExpiresAt";
const TTL_MS = 12 * 60 * 60 * 1000;

const isIdSegment = (segment) =>
  /^\d+$/.test(segment) ||
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    segment
  );

export function getModuleKeyFromPath(pathname) {
  const parts = (pathname || "").split("/").filter(Boolean);
  const key = parts.filter((part) => !isIdSegment(part)).join("-");
  return key || null;
}

export function hasNestedParentId(data) {
  if (!data || typeof data !== "object") return false;
  return Object.keys(data).some(
    (key) => key !== "companyId" && /Id$/i.test(key)
  );
}

function readPages() {
  try {
    const expiresAt = Number(localStorage.getItem(EXPIRES_KEY));
    if (!expiresAt || Date.now() > expiresAt) {
      localStorage.removeItem(PAGES_KEY);
      localStorage.removeItem(EXPIRES_KEY);
      return {};
    }
    const raw = localStorage.getItem(PAGES_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writePages(pages) {
  const existingExpiry = Number(localStorage.getItem(EXPIRES_KEY));
  const expiresAt =
    existingExpiry && Date.now() <= existingExpiry
      ? existingExpiry
      : Date.now() + TTL_MS;
  localStorage.setItem(PAGES_KEY, JSON.stringify(pages));
  localStorage.setItem(EXPIRES_KEY, String(expiresAt));
}

export function getPagination(moduleKey) {
  if (!moduleKey) return null;
  const value = readPages()[moduleKey];
  if (!Array.isArray(value) || value.length < 2) return null;
  const pageNum = Number(value[0]);
  const pageSize = Number(value[1]);
  if (!Number.isFinite(pageNum) || !Number.isFinite(pageSize) || pageSize < 1) {
    return null;
  }
  return {
    page: Math.max(0, Math.floor(pageNum) - 1),
    pageSize: Math.floor(pageSize),
  };
}

export function setPagination(moduleKey, pageNum, pageSize) {
  if (!moduleKey) return;
  const pages = readPages();
  pages[moduleKey] = [Number(pageNum) || 1, Number(pageSize) || 20];
  writePages(pages);
}
